<template>
<div>
    <PropList :propType="'new'" />
</div>
</template>

<script>
import PropList from './List.vue'
export default {

    components: {
        PropList
    },

    data: () => ({

    }),

    computed: {

    },

    watch: {

    },
    methods: {

    },
    created() {

    },
};
</script>
